// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__9KASi","assignButton":"CreateEditEquipmentSchedule_assignButton__2pIVT"};